const userTour = `
query getTour($tourAbbrv: String!, $version: IntType!) {
  tour (filter: { 
    abbrv: { 
      matches: {
        pattern: $tourAbbrv, caseSensitive: false
      }
    },
    version: {
      eq: $version
    }
  })
  {
    id
    name
    abbrv
    location {
      latitude
      longitude
    }
    suspects {
      id
      name
      view {
        id
        url
      }
      enlargedMugshot {
        id
				url
      }
      active
      availableAfter {
        aaRestIndex
        aaViewIndex
        aaDialogIndex
      }
      clues {
        id
        active
        read
        clue
        availableAfter {
          aaRestIndex
          aaViewIndex
          aaDialogIndex
        }
      }
    }
    restaurants {
      id
      idString
      iconType
      views {
      	id
        idString
        hints {
          id
					hintType
          image {
            id
            url
          }
          message
        }
        inputAnswer
        inputQuestion
        message
        url {
          id
          url
        }
        viewType
        viewId
        dialogUrls {
          id
          url
        }
      }
      location {
        latitude
        longitude
      }
    }
  }
}
`
const productionTour = `
query getProductionTour($tourAbbrv: String!, $version: IntType!) {
  productionTour (filter: {
    abbrv: {
      matches: {
        pattern: $tourAbbrv,
        caseSensitive: false
      }
    },
    version: {
      eq: $version
    }
  })
  {
    id
    abbrv
    version
    tourId
    tour {
      id
      name
      location {
        latitude
        longitude
      }
      suspects {
        id
        name
        active
        view {
          id
          url
        }
        enlargedMugshot {
          id
          url
        }
        availableAfter {
          aaRestIndex
          aaViewIndex
          aaDialogIndex
        }
        clues {
          id
          active
          read
          clue
          availableAfter {
            aaRestIndex
            aaViewIndex
            aaDialogIndex
          }
        }
      }
      restaurants {
        id
        idString
        iconType
        name
        
        location {
          latitude
          longitude
        }
        views {
          ... on BulletinViewRecord {
            id
            viewId
            viewType
            url {
              id
              url
            }
            viewType
            viewId
          }
          ... on VideoViewRecord {
            id
            viewId
            viewType
            videoFile {
              id
              url
            }
          }
          ... on QuizViewRecord {
            id
            inputAnswer
            inputQuestion
            viewId
            viewType
            finalInput
            correct
            hints {
              ... on ImageHintRecord {
                id
                hintType
                image {
                  url
                  id
                }
              }
              ... on TextHintRecord {
                id
                hintType
                message
              }
            }
          }
          ... on DirectionsViewRecord {
            id
            url {
              url
              id
            }
            viewType
            viewId
          }
          ... on DialogViewRecord {
            id
            viewId
            viewType
            dialogUrls {
              url
              id
            }
          }
          ... on TapToInterrogateViewRecord {
            id
            viewId
            viewType
            url {
              url
              id
            }
          }
          ... on TourIntroductionViewRecord {
            id
            viewId
            viewType
            url {
              url
              id
            }
          }
          ... on DirectorBulletinViewRecord {
            id
            viewId
            viewType
            dialogUrls {
              url
              id
            }
          }
          ... on StopEatViewRecord {
            id
            viewId
            viewType
            url {
              url
              id
            }
          }
          ... on EndOfTourSuspectLineupRecord {
            id
            viewId
            viewType     
          }
        }
      }
    }
  }
}
`

export default {
  userTour,
  productionTour
};